import * as React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import Typography from "@material-ui/core/Typography";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import { User, Report, Category } from "../../api/classes";
import { Link } from "react-router-dom";
import * as routes from "../../routes";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Menu, MenuItem } from "@material-ui/core";
import MoreSettings from "../../components/more";
import { render } from "react-dom";
import EditCategory from "./edit";
import ApproveDialog from "../../components/dialogs/approveDialog";
import EmptyState from "src/components/emptyState";
import { DubitoSvc } from "src/api";
import { GlobalState } from "src/store";
import * as actions from "../../store/cases/actions";
import { connect } from "react-redux";
import { Permissions } from "src/api/constants";
import { hasPermissionOf } from "src/auth/auth";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      textAlign: "center"
      //   paddingTop: theme.spacing.unit * 20
    }
  });

type State = {
  open: boolean;
};
const styles1 = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  },
  table: {
    minWidth: 700
  }
});

interface Props {
  classes: any;
  elements: Category[];
  fetchCategories: () => void;
}
class CategoryTable extends React.Component<Props> {
  state = {
    element: undefined,
    editOpen: false,
    deleteOpen: false
  };
  openAddCategory = () => {
    this.setState({ editOpen: true, deleteOpen: false, element: undefined });
  };
  openDeleteCategory = () => {
    this.setState({ editOpen: false, deleteOpen: true });
  };
  closeAddCategory = () => {
    this.setState({ editOpen: false, deleteOpen: false, element: undefined });
  };
  closeDeleteCategory = () => {
    this.setState({ editOpen: false, deleteOpen: false });
  };
  deleteCategory = () => {
    DubitoSvc.deleteCategory({ category_id: this.state.element.id }).then(
      () => {
        this.props.fetchCategories();
        // this.props
        this.closeDeleteCategory();
      }
    );
  };
  renderEditAndDelete() {
    return (
      <>
        <EditCategory
          element={this.state.element}
          open={this.state.editOpen}
          onCancel={this.closeDeleteCategory}
          onEdit={() => {
            this.setState({ editOpen: false });
          }}
        />
        {this.state.element && this.state.deleteOpen && (
          <ApproveDialog
            title={this.state.element.title}
            description={
              "Do you really want to delete " +
              this.state.element.title +
              " category?"
            }
            open={this.state.deleteOpen}
            onCancel={this.closeAddCategory}
            onApprove={this.deleteCategory}
          />
        )}
      </>
    );
  }
  render() {
    const { classes, elements } = this.props;
    const canEdit = hasPermissionOf(Permissions.EDIT_CATEGORIES);

    return (
      <Paper className={classes.root}>
        {this.renderEditAndDelete()}
        <Toolbar>
          <div className={classes.title}>
            <Typography variant="title" id="tableTitle">
              Categories
            </Typography>
          </div>
          <div className={classes.spacer} />
          <div className={classes.actions}>
            <Tooltip title="Add Category">
              <IconButton
                onClick={this.openAddCategory}
                aria-label="Add Category"
              >
                <AddIcon />
              </IconButton>
            </Tooltip>
          </div>
        </Toolbar>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Case Count</TableCell>
              <TableCell>Created At</TableCell>
              {canEdit && <TableCell />}
            </TableRow>
          </TableHead>
          <TableBody>
            {elements &&
              elements.map((row: Category) => {
                return (
                  <TableRow key={row.id}>
                    <TableCell>{row.id}</TableCell>
                    <TableCell>
                      <Link
                        to={routes.PATH_CASES + "?category=" + row.title}
                        style={{ textDecoration: "none" }}
                      >
                        {row.title}
                      </Link>{" "}
                    </TableCell>
                    <TableCell> {row.case_count} </TableCell>
                    <TableCell> {row.created_at}</TableCell>
                    {canEdit && (
                      <TableCell>
                        <MoreSettings
                          options={[
                            {
                              label: "Edit",
                              onClick: () => {
                                this.setState({ editOpen: true, element: row });
                              }
                            },
                            {
                              label: "Delete",
                              onClick: () => {
                                this.setState({
                                  deleteOpen: true,
                                  element: row
                                });
                              }
                            }
                          ]}
                        />
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
        {!elements ||
          (elements.length === 0 && (
            <div style={{ paddingBottom: 72 }}>
              <EmptyState message="There is no category yet. You may create one by pressing + icon at the top." />
            </div>
          ))}
      </Paper>
    );
  }
}
export default connect(
  (state: GlobalState, own: any) => ({}),
  dispatch => ({
    fetchCategories: (): any => dispatch(actions.fetchCategories())
  })
)(withStyles(styles)(CategoryTable));



// WEBPACK FOOTER //
// ./src/pages/categories/table.tsx